import { render, staticRenderFns } from "./cutoff-time-table.vue?vue&type=template&id=2863560a"
import script from "./cutoff-time-table.vue?vue&type=script&lang=js"
export * from "./cutoff-time-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports